import logo from './logo.svg';
import './App.scss';
import Navbar from './components/Navbar/Navbar';
import {Header ,About,Skills,Work,Testimonial,Footer} from './container'

function App() {
  return (
    <div className="app">
     <Navbar/>
     <Header/>
    <About />
    <Work />
     <Skills />
    
    <Testimonial />
   <Footer /> 
  </div>
  );
}

export default App;
